import { FC } from "react";
import Content from "./Content";
import {Header ,SideNav} from "../../component/index";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from 'chart.js';

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController
);

const Layout: FC = () => {
  return (
    <div>
      <div className="dashboard">
        <Header/>
        <div className="d-flex">
          <SideNav/>
          <div className="main-wrapper">
            <Content />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
